import * as staticDict from '@/staticDict'
import * as flowStaticDict from '@/staticDict/flowStaticDict'
export default class DictionaryController {
  static dictSysRole (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('admin/upms/sysRole/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('角色字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  // 全局编码字典
  static dictGlobalDict (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('admin/upms/globalDict/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('编码字典');
        dictData.setList((res.data || []).map(item => {
          return {
            ...item,
            // 设置已禁用编码字典数据项
            disabled: item.status === 1
          }
        }));
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }

  static dictGlobalDictByIds (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('admin/upms/globalDict/listDictByIds', 'post', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('编码字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }

  static dictSysUserStatus () {
    return new Promise((resolve) => {
      resolve(staticDict.SysUserStatus);
    });
  }
  static dictSysUserType () {
    return new Promise((resolve) => {
      resolve(staticDict.SysUserType);
    });
  }
  static dictYesOrNoDict () {
    return new Promise((resolve) => {
      resolve(staticDict.YesOrNoDict);
    });
  }
  static dictGenderDict () {
    return new Promise((resolve) => {
      resolve(staticDict.GenderDict);
    });
  }
  static dictRSTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.RSTypeDict);
    });
  }
  static dictInfoTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.InfoTypeDict);
    });
  }
  static dictAuditStatusDict () {
    return new Promise((resolve) => {
      resolve(staticDict.AuditStatusDict);
    });
  }
  static dictSpecialistTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.SpecialistTypeDict);
    });
  }
  static dictCourseTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.CourseTypeDict);
    });
  }
  static dictMemberTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.MemberTypeDict);
    });
  }
  static dictScoreDict () {
    return new Promise((resolve) => {
      resolve(staticDict.ScoreDict);
    });
  }
  static dictDegreeLevelDict () {
    return new Promise((resolve) => {
      resolve(staticDict.DegreeLevelDict);
    });
  }
  static dictCollectTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.CollectTypeDict);
    });
  }
  static dictValidityDict () {
    return new Promise((resolve) => {
      resolve(staticDict.ValidityDict);
    });
  }
  static dictOpenDict () {
    return new Promise((resolve) => {
      resolve(staticDict.OpenDict);
    });
  }
  static dictIdentityDict () {
    return new Promise((resolve) => {
      resolve(staticDict.IdentityDict);
    });
  }
  static dictDocumentTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.DocumentTypeDict);
    });
  }
  static dictDistrictDict () {
    return new Promise((resolve) => {
      resolve(staticDict.DistrictDict);
    });
  }
  static dictIsDockingDict () {
    return new Promise((resolve) => {
      resolve(staticDict.IsDockingDict);
    });
  }
  static dictEducationDict () {
    return new Promise((resolve) => {
      resolve(staticDict.EducationDict);
    });
  }
  static dictFilingPassedDict () {
    return new Promise((resolve) => {
      resolve(staticDict.FilingPassedDict);
    });
  }
  static dictSysLatestApprovalStatusDict () {
    return new Promise((resolve) => {
      resolve(flowStaticDict.SysLatestApprovalStatus);
    });
  }
  static dictProcessDefinitionTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.ProcessDefinitionTypeDict);
    });
  }
  static dictRepeatDate () {
    return new Promise((resolve) => {
      resolve(staticDict.RepeatDate);
    });
  }
  static dictServiceType () {
    return new Promise((resolve) => {
      resolve(staticDict.ServiceType);
    });
  }
  static dictIntegralType () {
    return new Promise((resolve) => {
      resolve(staticDict.IntegralType);
    });
  }
  static dictParticipantsNumber () {
    return new Promise((resolve) => {
      resolve(staticDict.ParticipantsNumber);
    });
  }
  static dictCreateTypeDict () {
    return new Promise((resolve) => {
      resolve(staticDict.CreateTypeDict);
    });
  }
  static dictSysUserDict (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/upms/sysUser/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('系统专家字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictSysDept (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/upms/sysDept/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('部门字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictSysDeptByParentId (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/upms/sysDept/listDictByParentId', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('部门字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictSpecialist (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/specialist/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('专家字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictFeatureDict (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/sysFeature/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('标签词字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictFeatureDictByParentId (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/sysFeature/listDictByParentId', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('标签词字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictIndustryDict (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/sysIndustry/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('产业字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictIndustryDictByParentId (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/sysIndustry/listDictByParentId', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('产业字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictSysTitlesDict (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/sysTitles/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('职称字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictAreaDict (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/area/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('地区字典表');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictAreaStreet (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/area/listStreet', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('地区字典表');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictAreaDictByParentId (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/area/listDictByParentId', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('地区字典表');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictSysDataPermType () {
    return new Promise((resolve) => {
      resolve(staticDict.SysDataPermType);
    });
  }
  static dictDeptPost (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('admin/upms/sysDept/listSysDeptPostWithRelation', 'get', params, axiosOption, httpOption).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err);
      });
    });
  }

  static dictSysPost (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('admin/upms/sysPost/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('岗位字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
  static dictAppropriateChannelDict () {
    return new Promise((resolve) => {
      resolve(staticDict.AppropriateChannelDict);
    });
  }
  static dictExportSet (sender, params, axiosOption, httpOption) {
    return new Promise((resolve, reject) => {
      sender.doUrl('/admin/app/exportSet/listDict', 'get', params, axiosOption, httpOption).then(res => {
        let dictData = new staticDict.DictionaryBase('导出字典');
        dictData.setList(res.data);
        resolve(dictData);
      }).catch(err => {
        reject(err);
      });
    });
  }
}
